module.exports = __webpack_public_path__ + "img/btn-cst-art.e7785b5a.svg";